import {
  ChatBubbleOutline,
  Psychology,
  BoltOutlined,
} from '@mui/icons-material';
import AIBannerBase from 'components/AI/AIBanner/AIBannerBase/AIBannerBase';
import {
  SECONDARY_TEXT_COLOR,
  SECONDARY_TEXT_COLOR_HOVER,
} from 'components/AI/AIStyles';

const FEATURES = [
  {
    id: 'smart-reply',
    icon: <ChatBubbleOutline />,
    label: 'Smart Reply Suggestions',
    iconColor: SECONDARY_TEXT_COLOR,
  },
  {
    id: 'context-aware',
    icon: <Psychology />,
    label: 'Context-Aware Responses',
    iconColor: SECONDARY_TEXT_COLOR_HOVER,
  },
  {
    id: 'instant-analysis',
    icon: <BoltOutlined />,
    label: 'Instant Message Analysis',
    iconColor: '#EAB308',
  },
];

export const AIMessagesBanner = () => (
  <AIBannerBase
    features={FEATURES}
    title="AI-Powered Message Intelligence"
    description="Smart conversation management with AI-powered replies, context understanding, and automated responses."
  />
);
